'use client';

import type { PropsWithChildren } from 'react';

/**
 * Layout wrapper for the @tabs parallel route.
 * This ensures all tab pages are wrapped consistently.
 */
export default function TabsLayout({ children }: PropsWithChildren) {
  return <>{children}</>;
}
